import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/data/content";
import { Reveal } from "./Reveal";

export default function Faq() {
  return (
    <section id="faq" className="py-24 md:py-32 px-6 md:px-10 bg-cream" data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <div className="text-center">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Questions fréquentes</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-normal tracking-tight text-forest leading-[1.1]">
              Tout ce que vous devez savoir
            </h2>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-14 w-full">
            {FAQ.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-forest/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-cormorant text-xl md:text-2xl text-forest hover:no-underline py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-forest/70 text-base leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
